export default __webpack_public_path__ + "static/media/declarative-menu.d4b6f39d.jpeg";